import styled from "styled-components";
import RepeatingGridColumns from "./styled/RepeatingGridColumns";

const ImageCardList = styled(RepeatingGridColumns)`
    gap: 1rem;
    padding: 1rem;
`;

export default ImageCardList;